'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _volumeControl = require('./volume-control');

var _volumeControl2 = _interopRequireDefault(_volumeControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO: Add rendering of volume controls

/** @class BackgroundNoise
  * A component for playing background noise
  * in a virutal expo.  Only one such component
  * needs to be loaded into the app; doing so
  * adds the backgroundNoise api to the global
  * vexpo object.
  */
var BackgroundNoise = function (_Component) {
  _inherits(BackgroundNoise, _Component);

  /** @constructor
    * Initializes a new BackgroundNoise instance.
    */
  function BackgroundNoise(props) {
    _classCallCheck(this, BackgroundNoise);

    var _this = _possibleConstructorReturn(this, (BackgroundNoise.__proto__ || Object.getPrototypeOf(BackgroundNoise)).call(this, props));

    _this.state = {
      muteRequests: 0,
      volume: 1
    };
    _this.mute = _this.mute.bind(_this);
    _this.unmute = _this.unmute.bind(_this);
    _this.volume = _this.volume.bind(_this);
    return _this;
  }
  /** @method componentWillMount
    * Creates an audio element to play background
    * noise and adds the backgroundNoise api to the
    * global vexpo object.
    */


  _createClass(BackgroundNoise, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.audio = new window.Audio();
      this.audio.loop = true;
      //this.audio.src = this.props.src;
      if (!window.vexpo) window.vexpo = {};
      this.mute = this.mute.bind(this);
      this.unmute = this.unmute.bind(this);
      this.volume = this.volume.bind(this);
      window.vexpo.backgroundNoise = {
        mute: this.mute,
        unmute: this.unmute,
        volume: this.volume
      };
    }
    /** @method componentWillUnmount
      * Stops any playing audio as the component is unmounted.
      */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.audio.pause();
    }
    /** @method mute
      * Mutes the background noise.  Mute requests
      * are counted, so a corresponding number of
      * unmute requests must be made to unmute.
      */

  }, {
    key: 'mute',
    value: function mute() {
      var _this2 = this;

      console.log("mute!");
      var requestCount = this.state.muteRequests + 1;
      this.setState({
        muteRequests: requestCount
      }, function () {
        if (requestCount > 0) _this2.audio.pause();
      });
    }
    /** @method unmute
      * Unmutes the background noise.  Mute requests
      * are counted, so a corresponding number of
      * unmute requests must be made to unmute.
      */

  }, {
    key: 'unmute',
    value: function unmute() {
      var _this3 = this;

      var requestCount = this.state.muteRequests - 1;
      if (requestCount < 0) requestCount = 0;
      this.setState({
        muteRequests: requestCount
      }, function () {
        if (requestCount == 0) _this3.audio.play();
      });
    }
    /** @method volume
      * Returns the current audio element volume when
      * no arguments are passed, or sets the volume when
      * a volume is passed.
      * @prop {float} value (optional) - volume in the range [0,1]
      * where 0 is completely off, and 1 is as loud as
      * possible.
      */

  }, {
    key: 'volume',
    value: function volume(value) {
      var _this4 = this;

      console.log(value);
      if (!value) return this.audio.volume;
      var clampedValue = value < 0 ? 0 : value > 1 ? 1 : value;
      this.setState({ volume: clampedValue }, function () {
        _this4.audio.value = clampedValue;
      });
    }
    /** @method render
      * Renders the background noise element.
      */

  }, {
    key: 'render',
    value: function render() {
      var icon = "volume-up";
      if (this.state.volume == 0) {
        icon = "volume-off";
      } else if (this.state.volume < 0.5) {
        icon = "volume-down";
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          null,
          _react2.default.createElement(_reactFontawesome2.default, { name: icon })
        ),
        _react2.default.createElement(_volumeControl2.default, { setVolume: this.volume })
      );
    }
  }]);

  return BackgroundNoise;
}(_react.Component);

exports.default = BackgroundNoise;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/background-noise/background-noise.js
// module id = 910
// module chunks = 0